<template>
    <div class="col-12 mb-4" v-if="venue && venue.venue_working_hours && venue.venue_working_hours.length > 0">
        <div class="container-box">
            <div class="container-box-title">{{ translate.account.openingHours }}</div>
            <div class="container-box-content" id="profile-page-working-hours">
                <table>
                    <tbody>
                    <tr v-for="(value, index) in working_hours" :key="index">
                        <td>
                            <span class="grey-text text-uppercase">{{ translate.home.daysOfWeek[index] }}</span>
                        </td>
                        <td class="larger-min-w">
                            <span v-if="value.startTime && value.endTime">{{ value.startTime }} - {{ value.endTime }}</span>
                            <span v-else class="grey-text">{{translate.account.closed}}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

const data = () => {
    return {
        moment: moment,
        working_hours: [
            {day: 0, startTime: '', endTime: ''},
            {day: 1, startTime: '', endTime: ''},
            {day: 2, startTime: '', endTime: ''},
            {day: 3, startTime: '', endTime: ''},
            {day: 4, startTime: '', endTime: ''},
            {day: 5, startTime: '', endTime: ''},
            {day: 6, startTime: '', endTime: ''},
        ],
    }
};

function created() {
    if (_.get(this, 'venue.venue_working_hours')) {
        this.venue.venue_working_hours.forEach((entry) => {
            this.working_hours[entry.day].startTime = entry.time_start;
            this.working_hours[entry.day].endTime = entry.time_end;
        })
    }
}

export default {
    data,
    created,
    computed: {
        ...mapState(['translate']),
    },
    methods: {},
    props: ['venue'],
}
</script>
